import Vue from 'vue'
import Scrollactive from 'vue-scrollactive'

Vue.use(Scrollactive)
const el = document.querySelector('#accordion-links')
if (el != null) {
  // eslint-disable-next-line no-unused-vars
  const app = new Vue({
    el: '#accordion-links',
    data: {
      elements: []
    },
    mounted () {
      this.elements = this.$el.querySelectorAll('.scrollactive-item')
    }
  })
}
